import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiContactActionComponent } from './fi-contact-action.component';
import { FiAppTextSharedModule } from '../app-text';
import { FiContactsService } from './fi-contacts.service';
import { MatButtonModule } from '@angular/material/button';
import { ContactService } from './contact.service';
import { PhoneNumberContactComponent } from '@fi-shared/fi-contacts/phone-number-edit/phone-number-contact.component';
import { PhoneNumberContactsComponent } from '@fi-shared/fi-contacts/phone-number-contacts/phone-number-contacts.component';
import { ContactTypeComponent } from '@fi-shared/fi-contacts/contact-type/contact-type.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatDividerModule } from '@angular/material/divider';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { FiCustomValidatorsModule } from '@fi-shared/fi-directives/fi-custom-validators/fi-custom-validators.module';
import { FiErrorMessageModule } from '@fi-shared/fi-error-message';
import { MatInputModule } from '@angular/material/input';
import { FiCountriesSelectModule } from '@fi-shared/fi-contacts/fi-countries-select/fi-countries-select.module';

@NgModule({
    imports: [
        CommonModule,
        FiAppTextSharedModule,
        MatButtonModule,
        MatFormFieldModule,
        MatSelectModule,
        MatDividerModule,
        MatCheckboxModule,
        FormsModule,
        FiCustomValidatorsModule,
        FiErrorMessageModule,
        MatInputModule,
        FiCountriesSelectModule,
    ],
    declarations: [
        FiContactActionComponent,
        ContactTypeComponent,
        PhoneNumberContactComponent,
        PhoneNumberContactsComponent,
    ],
    providers: [FiContactsService, ContactService],
    exports: [
        FiContactActionComponent,
        ContactTypeComponent,
        PhoneNumberContactComponent,
        PhoneNumberContactsComponent,
    ],
})
export class FiContactsModule {}
